export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.wixstatic.com/media/0184a2_0aa23104823c4206814b649abba92ad0~mv2_d_3872_2592_s_4_2.jpg/v1/fill/w_1920,h_1080,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/0184a2_0aa23104823c4206814b649abba92ad0~mv2_d_3872_2592_s_4_2.jpg"
          alt="Professional waterproofing services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/60 to-slate-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="space-y-8">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-teal-500/20 backdrop-blur-sm border border-teal-400/30 rounded-full px-5 py-2">
            <i className="ri-shield-check-line text-teal-300 text-lg"></i>
            <span className="text-teal-100 text-sm font-medium">Licensed & Insured • License No. 534840</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight">
            Reliable Waterproofing &<br />
            <span className="text-teal-400">Moisture Protection</span> Solutions
          </h1>

          {/* Subheading */}
          <p className="text-xl sm:text-2xl text-slate-200 max-w-3xl mx-auto leading-relaxed">
            Protect your home or business with proven waterproofing systems from Grass Valley's trusted experts
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <a
              href="#contact"
              className="w-full sm:w-auto bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-list-3-line mr-2"></i>
              Request a Free Estimate
            </a>
            <a
              href="#services"
              className="w-full sm:w-auto bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              View Our Services
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-8 pt-8">
            <div className="flex items-center space-x-2 text-white">
              <i className="ri-time-line text-2xl text-teal-400"></i>
              <div className="text-left">
                <div className="text-2xl font-bold">15+</div>
                <div className="text-sm text-slate-300">Years Experience</div>
              </div>
            </div>
            <div className="flex items-center space-x-2 text-white">
              <i className="ri-star-fill text-2xl text-teal-400"></i>
              <div className="text-left">
                <div className="text-2xl font-bold">A+</div>
                <div className="text-sm text-slate-300">BBB Rating</div>
              </div>
            </div>
            <div className="flex items-center space-x-2 text-white">
              <i className="ri-shield-check-fill text-2xl text-teal-400"></i>
              <div className="text-left">
                <div className="text-2xl font-bold">100%</div>
                <div className="text-sm text-slate-300">Guaranteed Work</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
